export default class English {
    static 'id' = 'ID'
    static 'agent id' = 'Sales Team Member ID'
    static 'item id' = 'Item ID'
    static 'item type' = 'Item Type'
    static 'media id' = 'Image ID'
    static 'collection id' = 'Collection ID'
    static 'division id' = 'Community ID'
    static 'sales order rid' = 'Sales Order RID'
    static 'community model rid' = 'Community Floorplan RID'
    static 'community rid' = 'Community RID'
    static 'bunit rid' = 'Business Unit RID'
    static 'lot rid' = 'Lot RID'
    static 'meta:type' = 'Type'
    static 'meta:order' = 'Order'
    static 'meta:info:name' = 'Name'
    static 'meta:info:description' = 'Description'
    static 'meta:info:headline' = 'Marketing Headline'
    static 'meta:info:geo:lat' = 'Latitude'
    static 'meta:info:geo:lng' = 'Longitude'
    static 'meta:info:rate' = 'Rate'
    static 'meta:info:callout' = 'Callout'
    static 'meta:info:notes' = 'Internal Notes'
    static 'meta:info:address:street1' = 'Address'
    static 'meta:info:address:street2' = 'Address 2'
    static 'meta:info:address:city' = 'City'
    static 'meta:info:address:state' = 'State'
    static 'meta:info:address:zip' = 'Zip'
    static 'meta:info:sqft' = 'Sq Ft'
    static 'meta:info:sqft:max' = 'Max Sq Ft'
    static 'meta:info:sqft:min' = 'Min Sq Ft'
    static 'meta:info:price' = 'Price'
    static 'meta:info:price:max' = 'Max Price'
    static 'meta:info:price:min' = 'Min Price'
    static 'meta:info:garages' = 'Garages'
    static 'meta:info:garages:max' = 'Max Garages'
    static 'meta:info:garages:min' = 'Min Garages'
    static 'meta:info:website' = 'URL'
    static 'meta:info:bedrooms' = 'Beds'
    static 'meta:info:bedrooms:max' = 'Max Beds'
    static 'meta:info:bedrooms:min' = 'Min Beds'
    static 'meta:info:bathrooms:full' = 'Full Baths'
    static 'meta:info:bathrooms:half' = 'Half Baths'
    static 'meta:info:bathrooms:max:full' = 'Max Full Baths'
    static 'meta:info:bathrooms:min:full' = 'Min Full Baths'
    static 'meta:info:bathrooms:max:half' = 'Max Half Baths'
    static 'meta:info:bathrooms:min:half' = 'Min Half Baths'
    static 'meta:sales office:geo:lat' = 'Sales Office Latitude'
    static 'meta:sales office:geo:lng' = 'Sales Office Longitude'
    static 'meta:sales office:email' = 'Email'
    static 'meta:sales office:phone' = 'Phone'
    static 'meta:sales office:hours:*:appointment' = '%s By Appointment'
    static 'meta:sales office:hours:*:start' = '%s Office Hours Start'
    static 'meta:sales office:hours:*:end' = '%s Office Hours End'
    static 'meta:sales office:address:street2' = 'Sales Office Address 2'
    static 'meta:sales office:address:street1' = 'Sales Office Address'
    static 'meta:sales office:address:zip' = 'Sales Office Zip'
    static 'meta:sales office:address:city' = 'Sales Office City'
    static 'meta:sales office:address:state' = 'Sales Office State'
    static 'meta:sales office:address:in collection' = 'Sales Office On-Site'
    static 'meta:sales office:address:in community' = 'Sales Office On-Site'
    static 'meta:videos:*:url' = 'Video %d URL'
    static 'meta:videos:*:type' = 'Video %d Type'
    static 'meta:videos:*:title' = 'Video %d Title'
    static 'meta:interactives:*:url' = 'Interactive %d URL'
    static 'meta:interactives:*:type' = 'Interactive %d Type'
    static 'meta:interactives:*:title' = 'Interactive %d Title'
    static 'meta:interactives:*:flash' = 'Interactive %d Uses Flash'
    static 'status' = 'Status'
    static 'value:new' = 'Recently Added'
    static 'value:active' = 'Published'
    static 'value:inactive' = 'Unpublished'
    static 'days' = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
    static 'kova:active' = 'Kova Active'
    static 'kova:BasePrice' = 'Kova Price'
    static 'kova:price ranges:max' = 'Kova Max Price'
    static 'kova:price ranges:min' = 'Kova Min Price'
    static 'kova:Baths:full' = 'Kova Full Bathrooms'
    static 'kova:Heading' = 'Kova Heading'
    static 'kova:MktDescr' = 'Kova Marketing Description'
    static 'kova:NumBaths' = 'Kova Bathrooms'
    static 'kova:NumGarages' = 'Kova Garages'
    static 'kova:NumBedrooms' = 'Kova Bedrooms'
    static 'kova:PresentationImageUrl' = 'Kova Image'
    static 'kova:CustomFields:TextCommModelStatus1' = 'Kova Custom Status'
    static 'kova:CustomFields:TextLat1' = 'Kova Latitude'
    static 'kova:CustomFields:TextLong1' = 'Kova Longitude'
    static 'kova:CustomFields:IntDSHbed1' = 'Kova Custom Bedrooms'
    static 'kova:CustomFields:IntDSHsqft1' = 'Kova Custom Sq Ft'
    static 'kova:CustomFields:Text DSHRate' = 'Kova Custom Rate'
    static 'kova:CustomFields:IntDSHgarage1' = 'Kova Custom Garages'
    static 'kova:CustomFields:NTextDSHdesc1' = 'Kova Custom Description'
    static 'kova:CustomFields:MoneyDSHprice1' = 'Kova Custom Price'
    static 'kova:CustomFields:DecimalDSHbath1' = 'Kova Custom Bathrooms'
    static 'kova:BUnitFID' = 'Kova Business Unit FID'
    static 'kova:BUnitRID' = 'Kova Business Unit RID'
    static 'kova:City' = 'Kova City'
    static 'kova:CommunityFID' = 'Kova Community FID'
    static 'kova:CommunityID' = 'Kova Community ID'
    static 'kova:CommunityImageHeight' = 'Kova Community Image Height'
    static 'kova:CommunityImageUrl' = 'Kova Community Image Url'
    static 'kova:CommunityImageWidth' = 'Kova Community Image Width'
    static 'kova:CommunityMapUrl' = 'Kova Community Map URL'
    static 'kova:CommunityRID' = 'Kova Community RID'
    static 'kova:CustomFields:BoolCommMthPayOnWeb1' = 'Kova Custom Monthly Payment'
    static 'kova:CustomFields:DecimalCommFees1' = 'Kova Custom Fees'
    static 'kova:CustomFields:DecimalCommInsurance1' = 'Kova Custom Insurance'
    static 'kova:CustomFields:DecimalCommTaxes1' = 'Kova Custom Taxes'
    static 'kova:CustomFields:IntCommDownPay1' = 'Kova Custom Down Payment'
    static 'kova:CustomFields:Money_CommHOA1' = 'Kova Custom HOA'
    static 'kova:CustomFields:NTextHours1' = 'Kova Custom Hours'
    static 'kova:CustomFields:TextCommAlert1' = 'Kova Custom Alert'
    static 'kova:CustomFields:TextCommCreditScore1' = 'Kova Custom Credit Score'
    static 'kova:CustomFields:TextCommLat1' = 'Kova Custom Latitude'
    static 'kova:CustomFields:TextCommLoanType1' = 'Kova Custom Loan Type'
    static 'kova:CustomFields:TextCommLong1' = 'Kova Custom Longitude'
    static 'kova:CustomFields:TextCommWebStatus1' = 'Kova Custom Web Status'
    static 'kova:DDBDwgRID' = 'Kova DDBDwgRID'
    static 'kova:Description' = 'Kova Description'
    static 'kova:MarketingName' = 'Kova Marketing Name'
    static 'kova:Name' = 'Kova Name'
    static 'kova:ObjectFID' = 'Kova Object FID'
    static 'kova:SalesOfficeCity' = 'Kova Sales Office City'
    static 'kova:SalesOfficeCounty' = 'Kova Sales Office County'
    static 'kova:SalesOfficeEmail' = 'Kova Sales Office Email'
    static 'kova:SalesOfficeFax' = 'Kova Sales Office Fax'
    static 'kova:SalesOfficePhone1' = 'Kova Sales Office Phone 1'
    static 'kova:SalesOfficePhone2' = 'Kova Sales Office Phone 2'
    static 'kova:SalesOfficeState' = 'Kova Sales Office State'
    static 'kova:SalesOfficeStreet' = 'Kova Sales Office Street'
    static 'kova:SalesOfficeZip' = 'Kova Sales Office Zip'
    static 'kova:State' = 'Kova State'
    static 'kova:Status' = 'Kova Status'
    static 'kova:WebEnabled' = 'Kova Web Enabled'
    static 'kova:ZipCode' = 'Kova ZipCode'
    static 'kova:active' = 'Kova Active'
    static 'kova:BUnitID' = 'Kova Business Unit ID'
    static 'kova:CommunityFullId' = 'Kova Community Full ID'
    static 'kova:Country' = 'Kova Country'
    static 'kova:CustomFields:Text_API-BUnit-Builder' = 'Kova Custom Builder'
    static 'kova:CustomFields:Text_API-BUnit-Name' = 'Kova Custom Name'
    static 'kova:GeoLocLat' = 'Kova Latitude'
    static 'kova:GeoLocLng' = 'Kova Longitude'
    static 'kova:ParentRID' = 'Kova Parent RID'
    static 'kova:StreetAddress' = 'Kova Street Address'
    static 'kova:WebGroupName' = 'Kova Web Group Name'
    static 'kova:AdditionalImages' = 'Kova Additional Images'
    static 'kova:BrochureImageUrl' = 'Kova Brochure Image URL'
    static 'kova:CommunityModelName' = 'Kova Community Model Name'
    static 'kova:CommunityModelRID' = 'Kova Community Model RID'
    static 'kova:CustomFields:Text/Desc1' = 'Kova Custom '
    static 'kova:CustomFields:TextCommModelStatus1' = 'Kova Custom '
    static 'kova:DescrBaths' = 'Kova Description Bathrooms'
    static 'kova:DescrBedrooms' = 'Kova Description Bedrooms'
    static 'kova:DescrGarage' = 'Kova Description Garages'
    static 'kova:DescrSqf' = 'Kova Description Sq Ft'
    static 'kova:GarageHanding' = 'Kova Garage Handing'
    static 'kova:ModelFID' = 'Kova Model FID'
    static 'kova:ModelID' = 'Kova Model ID'
    static 'kova:ModelRID' = 'Kova Model RID'
    static 'kova:ModelYear' = 'Kova Model Year'
    static 'kova:PerspectiveImageUrl' = 'Kova Perspective Image URL'
    static 'kova:Sqf' = 'Kova Sq Ft'
    static 'kova:Style' = 'Kova Style'
    static 'kova:Type' = 'Kova Type'
    static 'kova:bathroom_ranges' = 'Kova Bathroom Ranges'
    static 'kova:bedroom_ranges' = 'Kova Bedroom Ranges'
    static 'kova:garage_ranges' = 'Kova Garage Ranges'
    static 'kova:price_ranges' = 'Kova Price Ranges'
    static 'kova:sqft_ranges' = 'Kova Sq Ft Ranges'
    static 'kova:SlsOrdID' = 'Kova Sales Order ID'
    static 'kova:HouseName' = 'Kova House Name'
    static 'kova:SlsOrdFID' = 'Kova Sales Order FID'
    static 'kova:SlsOrdRID' = 'Kova Sales Order RID'
    static 'kova:SlsWshFID' = 'Kova Sales Worksheet FID'
    static 'kova:ClosingDate' = 'Kova Closing Date'
    static 'kova:MktDescrHdr' = 'Kova Marketing Description Header'
    static 'kova:ReleaseDate' = 'Kova Release Date'
    static 'kova:ContractDate' = 'Kova Contract Date'
    static 'kova:CreationDate' = 'Kova Creation Date'
    static 'kova:CustomFields:TextCallout1' = 'Kova Custom Callout'
    static 'kova:CustomFields:TextIS1' = 'Kova Custom IS'
    static 'kova:CustomFields:TextHBC1' = 'Kova Custom HBC'
    static 'kova:CustomFields:Text_DSHRate' = 'Kova Custom Rate'
    static 'kova:CustomFields:TextDesc3' = 'Kova Custom Description 3'
    static 'kova:CustomFields:TextDesc4' = 'Kova Custom Description 4'
    static 'kova:CustomFields:TextDesc10' = 'Kova Custom Description 10'
    static 'kova:CustomFields:TextDesc11' = 'Kova Custom Description 11'
    static 'kova:CustomFields:TextDescItems1' = 'Kova Custom Description Items'
    static 'kova:CustomFields:TextSlsExpDesc1' = 'Kova Custom Sales Experience Description'
    static 'kova:CustomFields:DateTime_DSHSaleCommit' = 'Kova Custom Sale Commitment'
    static 'kova:CustomFields:NText_DSHStructOptions' = 'Kova Custom Structure Options'
    static 'kova:EstComplDate' = 'Kova Estimated Completion Date'
    static 'kova:IsMarketHome' = 'Kova Is Market Home'
    static 'kova:RatifiedDate' = 'Kova Ratified Date'
    static 'kova:EstClosingDate' = 'Kova Estimated Closing Date'
    static 'kova:LotStreetAddress' = 'Kova Lot Street Address'
    static 'kova:SlsWshRID' = 'Kova Sales Worksheet ID'
    static 'kova:PriceTotal' = 'Kova Total Price'
    static 'kova:ReleasedDate' = 'Kova Released Date'
    static 'kova:IsMarketHomeSO' = 'Kova Is Market Home SO'
    
    /**
     * Get the label for the associated key
     * 
     * @param {string} key 
     */
    static label(key) {
        if(key.includes('meta:videos') || key.includes('meta:interactives')) {
            let matches = key.match(/(.*?)\:([0-9]+)(.*)/, key);
            let newKey = `${matches[1]}:*${matches[3]}`
            let label = this[newKey] ?? null;
            if(label) {
                return label.replace('%d', (parseInt(matches[2]) + 1));
            }
        }

        if(key.includes('meta:sales office:hours')) {
            let matches = key.match(/(.*?)\:([0-9]+)(.*)/, key);
            let newKey = `${matches[1]}:*${matches[3]}`
            let label = this[newKey] ?? null;
            if(label) {
                return label.replace('%s', this.days[parseInt(matches[2])]);
            }
        }

        return this[key] ?? key.split(':').map(segment => segment.substring(0,1).toUpperCase() + segment.substring(1)).join(' ');
    }
}